import { render, staticRenderFns } from "./Otp2.vue?vue&type=template&id=28af2524&"
import script from "./Otp2.vue?vue&type=script&lang=js&"
export * from "./Otp2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports